import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-signin-redirect-callback',
  standalone: true,
  imports: [],
  template: `<div></div>`,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: ``
})
export class SigninRedirectCallbackComponent implements OnInit {

  constructor(private authService: AuthService, private router: Router) { }

  ngOnInit(): void {
    this.authService.finishLogin().then((value) => {
      // this.router.navigate([''], { replaceUrl: true });
    })
  }
}
